export enum GeneratedTripCountrySourceType {
  FromTacho = 0,
  FromGps = 1,
  MixMode = 2,
}
